// extracted by mini-css-extract-plugin
export var pageTitleContainer = "pageTitleNews-module--pageTitleContainer--BJUil";
export var pageTitleNews = "pageTitleNews-module--page-TitleNews--2yRTa";
export var pageTitleBgNews = "pageTitleNews-module--pageTitleBgNews--AC0lf";